import WarehouseService from "./WarehouseService";
import ModelUtils from "../../../utils/ModelUtils";
import AreaService from "./AreaService";
import ShelveService from "./ShelveService";
import PositionService from "./PositionService";
import {CM_ACTION_TYPE, DICT_KEY, getModel, setModel,refreshDict} from "../../../utils/constants";
const MODEL_KEY = DICT_KEY.BASE_WAREHOUSE
const storageModel = getModel(MODEL_KEY);
const warehouseModel = {
    state: !!storageModel ? storageModel : {
        warehouseList: [],
        areaList: [],
        shelveList: [],
        positionList: [],
        idshelveList:[],

        selectedWarehouse: null,
        selectedArea: null,
        selectedShelve: null,
        selectedPosition: null,

        pagePosition:{},
        pageShelveList:{},

        warehouseSelectedRowKeys: [],
        areaSelectedRowKeys: [],
        shelveSelectedRowKeys: [],
        positionSelectedRowKeys: [],

        areaActionType: CM_ACTION_TYPE.INSERT,
        shelveActionType: CM_ACTION_TYPE.INSERT,
        positionActionType: CM_ACTION_TYPE.INSERT,

        areaDrawerVisible: false,
        shelveDrawerVisible: false,
        positionDrawerVisible: false,

        tabsKey:null,

    },
    reducers: {
        setTabsKey(state, payload){
            state.tabsKey = payload;
            setModel(MODEL_KEY, {...state});
        },
        setAreaActionType(state, payload) {
            state.areaActionType = payload;
            setModel(MODEL_KEY, {...state});
        },
        setShelveActionType(state, payload) {
            state.shelveActionType = payload;
            setModel(MODEL_KEY, {...state});
        },
        setPositionActionType(state, payload) {
            state.positionActionType = payload;
            setModel(MODEL_KEY, {...state});
        },
        setWarehouseList(state, payload) {
            state.warehouseList = payload;
            setModel(MODEL_KEY, {...state});
        },
        setAreaList(state, payload) {
            state.areaList = payload;
            setModel(MODEL_KEY, {...state});
        },
        setShelveList(state, payload) {
            state.shelveList = payload;
            setModel(MODEL_KEY, {...state});
        },
        setIDshelveList(state, payload){
            state.idshelveList = payload;
            setModel(MODEL_KEY, {...state});
        },
        setPositionList(state, payload) {
            state.positionList = payload;
            setModel(MODEL_KEY, {...state});
        },
        setPagePosition(state, payload){
            state.pagePosition = payload;
            setModel(MODEL_KEY, {...state});
        },
        setPageShelveList(state, payload){
            state.pageShelveList = payload;
            setModel(MODEL_KEY, {...state});
        },
        setSelectedWarehouse(state, payload) {
            state.selectedWarehouse = payload;
            setModel(MODEL_KEY, {...state});
        },
        setSelectedArea(state, payload) {
            state.selectedArea = payload;
            setModel(MODEL_KEY, {...state});
        },
        setSelectedShelve(state, payload) {
            state.selectedShelve = payload;
            setModel(MODEL_KEY, {...state});
        },
        setSelectedPosition(state, payload) {
            state.selectedPosition = payload;
            setModel(MODEL_KEY, {...state});
        },
        setAreaDrawerVisible(state, payload) {
            state.areaDrawerVisible = payload;
            setModel(MODEL_KEY, {...state});
        },
        setShelveDrawerVisible(state, payload) {
            state.shelveDrawerVisible = payload;
            setModel(MODEL_KEY, {...state});
        },
        setPositionDrawerVisible(state, payload) {
            state.positionDrawerVisible = payload;
            setModel(MODEL_KEY, {...state});
        },

        setWarehouseSelectedRowKeys(state, payload) {
            state.warehouseSelectedRowKeys = payload;
            setModel(MODEL_KEY, {...state});
        },
        setAreaSelectedRowKeys(state, payload) {
            state.areaSelectedRowKeys = payload;
            setModel(MODEL_KEY, {...state});
        },
        setShelveSelectedRowKeys(state, payload) {
            state.shelveSelectedRowKeys = payload;
            setModel(MODEL_KEY, {...state});
        },
        setPositionSelectedRowKeys(state, payload) {
            state.positionSelectedRowKeys = payload;
            setModel(MODEL_KEY, {...state});
        },
    },
    effects: (dispatch) => ({
        async loadWarehouse({showMsg = true, duration = 5, data},) {
            const funName = "加载仓库";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";

            const func = async () => {
                const retData = await WarehouseService.findPage(data)
                let {list, ...page} = retData
                list.forEach((el) => el.key = el.id);
                this.setWarehouseList(list);
                return retData
            }
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func)

        },
        async loadArea({showMsg = true, duration = 5, data}) {
            const funName = "加载仓库区域";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await AreaService.findPage(data)
                let {list, ...page} = retData
                list.forEach((el) => el.key = el.id);
                this.setAreaList(list);
                return retData
            }
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func)

        },
        async loadShelve({showMsg = true, duration = 5, data}) {
            const funName = "加载货架";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await ShelveService.findPage(data)
                let {list, ...page} = retData
                list.forEach((el) => el.key = el.id);
                this.setShelveList(list);
                this.setPageShelveList(page)
                return retData
            }
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func)
        },
        //根据区域id加载货架
        async loadIdShelve({showMsg = true, duration = 5, data}) {
            const funName = "加载货架";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await ShelveService.findPage(data)
                let {list, ...page} = retData
                list.forEach((el) => el.key = el.id);
                this.setIDshelveList(list);
                return retData
            }
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func)
        },
        async loadPosition({showMsg = true, duration = 5, data}) {
            const funName = "加载货位";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await PositionService.findPage(data)
                let {list, ...page} = retData
                list.forEach((el) => el.key = el.id);
                this.setPositionList(list);
                this.setPagePosition(page)
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func)
        },
        async insertWarehouse({showMsg = true, duration = 5, data}) {
            const funName = "新增库房";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await WarehouseService.insert(data)
                const {cmDict} = dispatch;
                await refreshDict("WAREHOUSE", cmDict);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async updateWarehouse({showMsg = true, duration = 5, data}) {
            const funName = "修改库房";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await WarehouseService.update(data)
                const {cmDict} = dispatch;
                await refreshDict("WAREHOUSE", cmDict);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);            
        },
        async insertArea({showMsg = true, duration = 5, data}) {
            const funName = "新增区域";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData =  await AreaService.insert(data)
                const {cmDict} = dispatch;
                await refreshDict("AREA", cmDict);
                return retData                
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async updateArea({showMsg = true, duration = 5, data}) {
            const funName = "修改区域";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await AreaService.update(data)
                const {cmDict} = dispatch;
                await refreshDict("AREA", cmDict);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async insertShelve({showMsg = true, duration = 5, data}) {
            const funName = "新增货架";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await ShelveService.insert(data)
                const {cmDict} = dispatch;
                await refreshDict("SHELVE", cmDict);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async updateShelve({showMsg = true, duration = 5, data}) {
            const funName = "修改货架";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await ShelveService.update(data)
                const {cmDict} = dispatch;
                await refreshDict("SHELVE", cmDict);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async insertPosition({showMsg = true, duration = 5, data}) {
            const funName = "新增货位";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await PositionService.insert(data)
                const {cmDict} = dispatch;
                await refreshDict("POSITION", cmDict);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //批量新增货位
        async batchInsertShelfs({showMsg = true, duration = 5, data}) {
            const funName = "新增货位";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await PositionService.batchInsertShelfs(data)
                const {cmDict} = dispatch;
                await refreshDict("POSITION", cmDict);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async updatePosition({showMsg = true, duration = 5, data}) {
            const funName = "修改货位";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await PositionService.update(data)
                const {cmDict} = dispatch;
                await refreshDict("POSITION", cmDict);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        }
    })
}

export default warehouseModel;